import { FunctionComponent, PropsWithChildren } from 'react';

import { useNavigateToEdit } from '../../../../shared/hooks/use-navigate-to-edit/use-navigate-to-edit.hook';
import { FirmwareOverviewModel } from '../../../../shared/models/firmware-overview.model';
import Box from '../../../shared/components/ui/Box';
import Paper from '../../../shared/components/ui/Paper';
import Typography from '../../../shared/components/ui/Typography';
import { FileSizes } from '../../../shared/enums/file-sizes.enum';
import { convertBytes } from '../../../shared/utils/convert-bytes/convert-bytes.util';
import FirmwareDetailsColumn from '../FirmwareDetailsColumn/FirmwareDetailsColumn';

const FirmwareDetailsCell: FunctionComponent<
  Omit<FirmwareOverviewModel, 'status'>
> = (
  props: PropsWithChildren<Omit<FirmwareOverviewModel, 'status'>>
): JSX.Element => {
  const navigate = useNavigateToEdit(props.id);
  return (
    <Box>
      <Typography
        component={'h4'}
        sx={{
          fontSize: '24px',
          marginBottom: '16px',
          marginTop: '16px',
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: '26px',
          cursor: 'pointer',
        }}
        onClick={navigate}
      >
        {props.name}
      </Typography>

      <Paper sx={{ boxShadow: 'unset', display: 'flex', gap: '80px' }}>
        <FirmwareDetailsColumn
          title={'Platform'}
          content={`${
            props.platform
              ? `${props.platform?.name} ${props.platform?.version}`
              : ''
          }`}
          key={'Platform' + props.version + props.platform?.name}
        />

        <FirmwareDetailsColumn
          title={'ECU Model'}
          content={props.ecu.name}
          key={'ECU Model' + props.version + props.ecu}
        />

        <FirmwareDetailsColumn
          title={'Brand/Vehicle'}
          content={props.brand.name}
          key={'Brand/Vehicle' + props.version + props.brand.name}
        />

        <FirmwareDetailsColumn
          title={'Model'}
          content={props.model.name}
          key={'Model' + props.version + props.model.name}
        />

        <FirmwareDetailsColumn
          title={'Version'}
          content={props.version}
          key={'Version' + props.version + props.version}
        />

        <FirmwareDetailsColumn
          title={'Size'}
          content={convertBytes(props.size, FileSizes.GigaBytes, 1, 'GB')}
          key={'Size' + props.version + props.size}
        />
      </Paper>
    </Box>
  );
};

export default FirmwareDetailsCell;
